export default class SelectUrl {
    constructor(el) {
        el.addEventListener('change', this.goToUrl)
    }

    goToUrl = (e) => {
        window.location.href = e.target.value
    }
}
